<template>
    <client-page>
        <div class="sub-visual sub-visual--sv1">
            <v-container>
                <h2 class="sub-visual__title"><span>PRODUCT</span></h2>
            </v-container>
        </div>

        <div class="tab-wrap mb-2 mb-lg-2">
            <v-container>
                <v-tabs :value="tab" grow show-arrows center-active class="tab tab--line">
                    <v-tab v-for="{ value, text } in tabs" :key="value" :to="`/en/products/${value}`">
                        <span>{{ text }}</span>
                    </v-tab>
                </v-tabs>
            </v-container>
        </div>

        <v-tabs-items :value="tab" touchless>
            <!-- S: UWSS -->
            <private-sales-about />
            <!-- E: UWSS -->
            <!-- S: WEBCastle -->
            <private-sales-merit />
            <!-- E: WEBCastle -->
            <!-- S: WSFinder -->
            <private-sales-kata />
            <!-- E: WSFinder -->
            <!-- S: WMDS -->
            <private-sales-genre />
            <!-- E: WMDS -->
        </v-tabs-items>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import PrivateSalesAbout from "@/components/client/en/private/private-sales-about.vue";
import PrivateSalesMerit from "@/components/client/en/private/private-sales-merit.vue";
import PrivateSalesKata from "@/components/client/en/private/private-sales-kata.vue";
import PrivateSalesGenre from "@/components/client/en/private/private-sales-genre.vue";
import { PRIVATE_SALES_EN_TABS } from "@/assets/variables";
const tabs = Object.values(PRIVATE_SALES_EN_TABS);

export default {
    components: {
        ClientPage,
        PrivateSalesAbout,
        PrivateSalesMerit,
        PrivateSalesKata,
        PrivateSalesGenre,
    },
    props: {
        tab: { type: String, default: PRIVATE_SALES_EN_TABS.UWSS.value },
    },
    data() {
        return {
            tabs,
        };
    },
    mounted() {
        this.syncPath();
    },
    methods: {
        syncPath() {
            const path = `/en/products/${this.tab}`;
            if (this.$route.path !== path) this.$router.replace(path);
        },
    },
};
</script>
